import React from "react";
import "./BhimashankarPackage.css";

const itinerary = [
  {
    day: "Morning",
    places: ["Pune", "Bhimashankar"],
    stay: "Travel from Pune to Bhimashankar",
  },
  {
    day: "Darshan",
    places: ["Bhimashankar Jyotirlinga", "Temple Darshan"],
    stay: "Darshan & Local Visit",
  },
  {
    day: "Return",
    places: ["Bhimashankar", "Pune"],
    stay: "Same Day Return to Pune",
  },
];

const vehicles = [
  {
    name: "Sedan Cab",
    price: "₹4,000",
    icon: "🚘",
  },
  {
    name: "Ertiga Cab",
    price: "₹4,800",
    icon: "🚙",
  },
  {
    name: "Innova Crysta",
    price: "₹6,500",
    icon: "🚐",
    popular: true,
  },
  {
    name: "Innova Hycross",
    price: "₹8,300",
    icon: "🚐",
  },
];

export default function BhimashankarPackage() {
  return (
    <section className="ml-package">
      <div className="ml-container">

        {/* HEADER */}
        <div className="ml-header">
          <div className="ml-logo-box">
            <img
              src="/images/logo.jpg"
              alt="Garud Cabs"
              className="ml-logo"
            />
          </div>

          <div className="ml-header-content">
            <span className="ml-badge">
              SAME DAY RETURN
            </span>

            <h1>
              Pune to Bhimashankar
              <span> Jyotirlinga Darshan</span>
            </h1>

            <p>
              Book a comfortable Commercial Cab from Pune to Bhimashankar
              Jyotirlinga for a convenient same-day darshan trip with
              Garud Cabs.
            </p>
          </div>
        </div>

        {/* ROUTE */}
        <div className="ml-route">
          <span className="ml-route-label">
            DARSHAN ROUTE
          </span>

          <div className="ml-route-text">
            Pune <b>→</b> Bhimashankar Jyotirlinga
            <b> → </b> Temple Darshan
            <b> → </b> Pune
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div className="ml-main-grid">

          {/* TRIP PLAN */}
          <div className="ml-card ml-itinerary">

            <div className="ml-section-title">
              <div className="ml-number">01</div>

              <div>
                <small>SAME DAY DARSHAN</small>
                <h2>Trip Itinerary</h2>
              </div>
            </div>

            <div className="ml-timeline">

              {itinerary.map((item, index) => (
                <div
                  className="ml-timeline-item"
                  key={item.day}
                >
                  <div className="ml-day-number">
                    {index + 1}
                  </div>

                  <div className="ml-day-content">

                    <h3>{item.day}</h3>

                    <div className="ml-places">
                      {item.places.map((place, i) => (
                        <React.Fragment key={place}>

                          <span>{place}</span>

                          {i !== item.places.length - 1 && (
                            <b>→</b>
                          )}

                        </React.Fragment>
                      ))}
                    </div>

                    <div className="ml-stay">
                      🚖 {item.stay}
                    </div>

                  </div>
                </div>
              ))}

            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="ml-side">

            {/* INCLUDED */}
            <div className="ml-card ml-included">

              <span className="ml-small-label">
                PACKAGE INCLUDES
              </span>

              <h2>Cab Package Includes</h2>

              <div className="ml-included-grid">
                <div>✓ Fuel Charges</div>
                <div>✓ Driver Allowance</div>
                <div>✓ Commercial Cab</div>
                <div>✓ Same Day Return</div>
                <div>✓ Pune Pickup</div>
                <div>✓ Pune Drop</div>
              </div>

              <div className="ml-inclusive-note">
                ✓ Comfortable Pune – Bhimashankar – Pune Trip
              </div>

            </div>

            {/* TRIP DETAILS */}
            <div className="ml-card ml-tour-info">

              <h3>🙏 Bhimashankar Darshan</h3>

              <div className="ml-info-row">
                <span>Destination</span>
                <strong>Bhimashankar</strong>
              </div>

              <div className="ml-info-row">
                <span>Tour Type</span>
                <strong>Jyotirlinga Darshan</strong>
              </div>

              <div className="ml-info-row">
                <span>Duration</span>
                <strong>Same Day</strong>
              </div>

              <div className="ml-info-row">
                <span>Pickup</span>
                <strong>Pune</strong>
              </div>

              <div className="ml-info-row">
                <span>Return</span>
                <strong>Pune</strong>
              </div>

            </div>

            <div className="ml-package-note">

              <strong>
                Pune to Bhimashankar Same Day Cab
              </strong>

              <p>
                Travel comfortably from Pune to Bhimashankar
                Jyotirlinga, complete your darshan and return
                to Pune on the same day.
              </p>

            </div>

          </div>
        </div>

        {/* PRICING */}
        <div className="ml-pricing">

          <div className="ml-pricing-head">

            <div>
              <span className="ml-small-label">
                CHOOSE YOUR CAB
              </span>

              <h2>
                Bhimashankar Cab Package Price
              </h2>
            </div>

            <p>
              Pune → Bhimashankar → Pune
            </p>

          </div>

          <div className="ml-vehicle-grid">

            {vehicles.map((vehicle) => (
              <div
                className={`ml-vehicle-card ${
                  vehicle.popular ? "ml-popular" : ""
                }`}
                key={vehicle.name}
              >

                {vehicle.popular && (
                  <span className="ml-popular-tag">
                    POPULAR
                  </span>
                )}

                <div className="ml-vehicle-icon">
                  {vehicle.icon}
                </div>

                <div className="ml-vehicle-info">
                  <h3>{vehicle.name}</h3>

                  <small>
                    Same Day Package
                  </small>
                </div>

                <div className="ml-price">
                  {vehicle.price}
                </div>

              </div>
            ))}

          </div>
        </div>

        {/* BOOKING */}
        <div className="ml-booking">

          <div>
            <span>GARUD CABS • PUNE</span>

            <h2>
              Book Pune to Bhimashankar Cab
            </h2>

            <p>
              Same Day Return • Commercial Cab • Experienced Driver
            </p>
          </div>

          <a
            href="tel:+919970007784"
            className="ml-book-btn"
          >
            Book Your Cab →
          </a>

        </div>

      </div>
    </section>
  );
}